// Combine accounts i18n translation keys
export const COMBINE_ACCOUNTS_HEADER_KEY = 'combine_accounts_header';
export const COMBINE_ACCOUNTS_CLOSE_KEY = 'combine_accounts_close';
export const COMBINE_ACCOUNTS_CANCEL_KEY = 'combine_accounts_cancel';
export const COMBINE_ACCOUNTS_GO_BACK_KEY = 'combine_accounts_go_back';
export const COMBINE_ACCOUNTS_SUBMIT_KEY = 'combine_accounts_submit';
export const COMBINE_ACCOUNTS_NEXT_KEY = 'combine_accounts_next';
export const COMBINE_ACCOUNTS_DETAILS_HEADING_KEY =
  'combine_accounts_details_heading';
export const COMBINE_ACCOUNTS_DETAILS_DESCRIPTION_KEY =
  'combine_accounts_details_description';
export const COMBINE_ACCOUNTS_DETAILS_BUSINESS_NAME_KEY =
  'combine_accounts_details_business_name';
export const COMBINE_ACCOUNTS_DETAILS_PHONE_NUMBER_KEY =
  'combine_accounts_details_phone_number';
export const COMBINE_ACCOUNTS_DETAILS_WEBSITE_KEY =
  'combine_accounts_details_website';
export const COMBINE_ACCOUNTS_DETAILS_ADDRESS_KEY =
  'combine_accounts_details_address';
export const COMBINE_ACCOUNTS_DETAILS_BILLING_REG_NUM_KEY =
  'combine_accounts_details_billing_reg_num';
export const COMBINE_ACCOUNTS_DETAILS_CURRENCY_KEY =
  'combine_accounts_details_currency';
export const COMBINE_ACCOUNTS_DETAILS_TIMEZONE_KEY =
  'combine_accounts_details_timezone';
export const COMBINE_ACCOUNTS_DETAILS_INDUSTRY_KEY =
  'combine_accounts_details_industry';
export const COMBINE_ACCOUNTS_DETAILS_DISPLAY_NAME_KEY =
  'combine_accounts_details_display_name';
export const COMBINE_ACCOUNTS_DETAILS_CHANGE_KEY =
  'combine_accounts_details_change';
export const COMBINE_ACCOUNTS_DETAILS_TILE_TITLE_KEY =
  'combine_accounts_details_tile_title';
export const COMBINE_ACCOUNTS_DETAILS_TILE_SUBTEXT_KEY =
  'combine_accounts_details_tile_subtext';
export const COMBINE_ACCOUNTS_DETAILS_LOADING_KEY =
  'combine_accounts_details_loading';
export const COMBINE_ACCOUNTS_DETAILS_ERROR_KEY =
  'combine_accounts_details_error';
export const COMBINE_ACCOUNTS_DETAILS_MISSING_PARAMS_KEY =
  'combine_accounts_details_missing_params';

// Edit mode
export const COMBINE_ACCOUNTS_DETAILS_SAVE_KEY =
  'combine_accounts_details_save';
export const COMBINE_ACCOUNTS_DETAILS_CANCEL_KEY =
  'combine_accounts_details_cancel';

// Account type discriminators
export const ACCOUNT_TYPE_SA = 'sa' as const;
export const ACCOUNT_TYPE_DSP = 'dsp' as const;

// URL search param keys
export const GA_PARAM = 'ga';
export const CFID_PARAM = 'cfid';
export const COMBINE_ACCOUNTS_DETAILS_TYPE_SA_KEY =
  'combine_accounts_details_type_sa';
export const COMBINE_ACCOUNTS_DETAILS_TYPE_DSP_KEY =
  'combine_accounts_details_type_dsp';
export const COMBINE_ACCOUNTS_STEP_ACCOUNT_DETAILS_KEY =
  'combine_accounts_step_account_details';
export const COMBINE_ACCOUNTS_STEP_BILLING_DETAILS_KEY =
  'combine_accounts_step_billing_details';
export const COMBINE_ACCOUNTS_STEP_REVIEW_KEY = 'combine_accounts_step_review';
export const COMBINE_ACCOUNTS_REVIEW_HEADING_KEY =
  'combine_accounts_review_heading';
export const COMBINE_ACCOUNTS_REVIEW_ACCOUNTS_TO_COMBINE_KEY =
  'combine_accounts_review_accounts_to_combine';
export const COMBINE_ACCOUNTS_REVIEW_LINKED_TO_KEY =
  'combine_accounts_review_linked_to';
export const COMBINE_ACCOUNTS_REVIEW_NEW_ACCOUNT_KEY =
  'combine_accounts_review_new_account';

// Confirmation modal
export const COMBINE_ACCOUNTS_CONFIRM_HEADER_KEY =
  'combine_accounts_confirm_header';
export const COMBINE_ACCOUNTS_CONFIRM_BODY_KEY =
  'combine_accounts_confirm_body';
export const COMBINE_ACCOUNTS_CONFIRM_BULLET_CAMPAIGNS_KEY =
  'combine_accounts_confirm_bullet_campaigns';
export const COMBINE_ACCOUNTS_CONFIRM_BULLET_INVOICES_KEY =
  'combine_accounts_confirm_bullet_invoices';
export const COMBINE_ACCOUNTS_CONFIRM_BULLET_USERS_KEY =
  'combine_accounts_confirm_bullet_users';
export const COMBINE_ACCOUNTS_CONFIRM_BULLET_FEATURES_KEY =
  'combine_accounts_confirm_bullet_features';
export const COMBINE_ACCOUNTS_CONFIRM_BULLET_MANAGE_KEY =
  'combine_accounts_confirm_bullet_manage';
export const COMBINE_ACCOUNTS_CONFIRM_CHECKBOX_KEY =
  'combine_accounts_confirm_checkbox';
export const COMBINE_ACCOUNTS_CONFIRM_SUBMIT_KEY =
  'combine_accounts_confirm_submit';
export const COMBINE_ACCOUNTS_CONFIRM_ERROR_KEY =
  'combine_accounts_confirm_error';
export const COMBINE_ACCOUNTS_REVIEW_TYPE_DSP_KEY =
  'combine_accounts_review_type_dsp';
export const COMBINE_ACCOUNTS_REVIEW_TYPE_SA_KEY =
  'combine_accounts_review_type_sa';
export const COMBINE_ACCOUNTS_REVIEW_TYPE_ADVERTISER_KEY =
  'combine_accounts_review_type_advertiser';

// Choose page error messages
export const COMBINE_ACCOUNTS_ERROR_MAX_ACCOUNTS_KEY =
  'combine_accounts_error_max_accounts';
export const COMBINE_ACCOUNTS_ERROR_DUPLICATE_DSP_KEY =
  'combine_accounts_error_duplicate_dsp';
export const COMBINE_ACCOUNTS_ERROR_DUPLICATE_SA_KEY =
  'combine_accounts_error_duplicate_sa';
export const COMBINE_ACCOUNTS_ERROR_INELIGIBLE_KEY =
  'combine_accounts_error_ineligible';
export const COMBINE_ACCOUNTS_ERROR_INCOMPATIBLE_KEY =
  'combine_accounts_error_incompatible';
export const COMBINE_ACCOUNTS_ERROR_NOT_ELIGIBLE_KEY =
  'combine_accounts_error_not_eligible';
export const COMBINE_ACCOUNTS_ERROR_VALIDATION_FAILED_KEY =
  'combine_accounts_error_validation_failed';
export const COMBINE_ACCOUNTS_LOADING_KEY = 'combine_accounts_loading';
export const COMBINE_ACCOUNTS_LOAD_MORE_KEY = 'combine_accounts_load_more';
export const COMBINE_ACCOUNTS_LOAD_MORE_ACCOUNTS_KEY =
  'combine_accounts_load_more_accounts';

// Landing page
export const COMBINE_LANDING_LEARN_MORE_KEY = 'combine_landing_learn_more';
export const COMBINE_LANDING_HEADING_KEY = 'combine_landing_heading';
export const COMBINE_LANDING_BENEFIT_FULLFUNNEL_HEADING_KEY =
  'combine_landing_benefit_fullfunnel_heading';
export const COMBINE_LANDING_BENEFIT_FULLFUNNEL_DESCRIPTION_KEY =
  'combine_landing_benefit_fullfunnel_description';
export const COMBINE_LANDING_BENEFIT_GLOBAL_HEADING_KEY =
  'combine_landing_benefit_global_heading';
export const COMBINE_LANDING_BENEFIT_GLOBAL_DESCRIPTION_KEY =
  'combine_landing_benefit_global_description';
export const COMBINE_LANDING_BENEFIT_STREAMLINE_HEADING_KEY =
  'combine_landing_benefit_streamline_heading';
export const COMBINE_LANDING_BENEFIT_STREAMLINE_DESCRIPTION_KEY =
  'combine_landing_benefit_streamline_description';
export const COMBINE_LANDING_ACTION_COMBINE_HEADING_KEY =
  'combine_landing_action_combine_heading';
export const COMBINE_LANDING_ACTION_COMBINE_DESCRIPTION_KEY =
  'combine_landing_action_combine_description';
export const COMBINE_LANDING_ACTION_COMBINE_LINK_KEY =
  'combine_landing_action_combine_link';
export const COMBINE_LANDING_ACTION_UPGRADE_HEADING_KEY =
  'combine_landing_action_upgrade_heading';
export const COMBINE_LANDING_ACTION_UPGRADE_DESCRIPTION_KEY =
  'combine_landing_action_upgrade_description';
export const COMBINE_LANDING_ACTION_UPGRADE_LINK_KEY =
  'combine_landing_action_upgrade_link';

// Upgrade accounts
export const UPGRADE_ACCOUNTS_HEADER_KEY = 'upgrade_accounts_header';
export const UPGRADE_ACCOUNTS_CHOOSE_HEADING_KEY =
  'upgrade_accounts_choose_heading';
export const UPGRADE_ACCOUNTS_CHOOSE_DESCRIPTION_KEY =
  'upgrade_accounts_choose_description';
export const UPGRADE_ACCOUNTS_SELECTED_COUNT_KEY =
  'upgrade_accounts_selected_count';
export const UPGRADE_ACCOUNTS_CONFIRM_HEADER_KEY =
  'upgrade_accounts_confirm_header';
export const UPGRADE_ACCOUNTS_CONFIRM_BODY_KEY =
  'upgrade_accounts_confirm_body';
export const UPGRADE_ACCOUNTS_CONFIRM_BULLET_CAMPAIGNS_KEY =
  'upgrade_accounts_confirm_bullet_campaigns';
export const UPGRADE_ACCOUNTS_CONFIRM_BULLET_USERS_KEY =
  'upgrade_accounts_confirm_bullet_users';
export const UPGRADE_ACCOUNTS_CONFIRM_BULLET_FEATURES_KEY =
  'upgrade_accounts_confirm_bullet_features';
export const UPGRADE_ACCOUNTS_CONFIRM_CHECKBOX_KEY =
  'upgrade_accounts_confirm_checkbox';
export const UPGRADE_ACCOUNTS_CONFIRM_SUBMIT_KEY =
  'upgrade_accounts_confirm_submit';
export const UPGRADE_ACCOUNTS_CONFIRM_PENDING_HEADER_KEY =
  'upgrade_accounts_confirm_pending_header';
export const UPGRADE_ACCOUNTS_CONFIRM_PENDING_BODY_KEY =
  'upgrade_accounts_confirm_pending_body';
export const UPGRADE_ACCOUNTS_CONFIRM_ERROR_KEY =
  'upgrade_accounts_confirm_error';

// Replaces the confirmation modal's body while the upgrade request is running.
// Deliberately not the existing combine_accounts_loading, whose value carries an
// ellipsis and whose note describes the Load more spinner on the account list.
export const UPGRADE_ACCOUNTS_LOADING_KEY = 'upgrade_accounts_loading';

/*
  Progress and outcome copy on the combine and upgrade landing page.

  These live on the landing page rather than the choose page because an upgrade
  that outlives the short window returns the user here, and the outcome is
  reported where they end up rather than where they started.

  Each count-bearing message has a `_ONE` companion. This package uses no ICU
  plurals anywhere, so a count is guarded in code and the singular is its own
  entry, matching how the billing summary avoids "1 countries". The singular
  entries deliberately carry no placeholder, since their count is always one and
  a placeholder a translation can drop is a placeholder that can go missing.
*/
export const UPGRADE_ACCOUNTS_IN_PROGRESS_SNACKBAR_KEY =
  'upgrade_accounts_in_progress_snackbar';
export const UPGRADE_ACCOUNTS_IN_PROGRESS_SNACKBAR_ONE_KEY =
  'upgrade_accounts_in_progress_snackbar_one';
export const UPGRADE_ACCOUNTS_SUCCESS_BANNER_KEY =
  'upgrade_accounts_success_banner';
export const UPGRADE_ACCOUNTS_SUCCESS_BANNER_ONE_KEY =
  'upgrade_accounts_success_banner_one';
export const UPGRADE_ACCOUNTS_VIEW_ACCOUNTS_KEY =
  'upgrade_accounts_view_accounts';
export const UPGRADE_ACCOUNTS_GO_TO_CAMPAIGNS_KEY =
  'upgrade_accounts_go_to_campaigns';
export const UPGRADE_ACCOUNTS_FAILURE_BANNER_KEY =
  'upgrade_accounts_failure_banner';
export const UPGRADE_ACCOUNTS_FAILURE_BANNER_ONE_KEY =
  'upgrade_accounts_failure_banner_one';

/*
  The Requests table on the combine and upgrade landing page, listing pending
  account-combination requests in both directions.

  The tab labels carry a count but need no `_ONE` companion, unlike the upgrade
  reporting copy above: the count sits in brackets after a label that does not
  change with it, so "Received (1)" is already correct.

  Only PENDING has a designed status label. Every other state the service reports
  is rendered exactly as it arrives, because the BFF passes GRS's string through
  rather than modelling it, and inventing copy for a state nobody has confirmed
  would put a wrong label in front of a customer. Add entries here as states are
  confirmed.
*/
export const COMBINE_REQUESTS_HEADING_KEY = 'combine_requests_heading';
export const COMBINE_REQUESTS_TAB_RECEIVED_KEY =
  'combine_requests_tab_received';
export const COMBINE_REQUESTS_TAB_SENT_KEY = 'combine_requests_tab_sent';
export const COMBINE_REQUESTS_COLUMN_REQUEST_TYPE_KEY =
  'combine_requests_column_request_type';
export const COMBINE_REQUESTS_REQUEST_TYPE_TOOLTIP_INTRO_KEY =
  'combine_requests_request_type_tooltip_intro';
export const COMBINE_REQUESTS_REQUEST_TYPE_TOOLTIP_COMBINE_HEADER_KEY =
  'combine_requests_request_type_tooltip_combine_header';
export const COMBINE_REQUESTS_REQUEST_TYPE_TOOLTIP_COMBINE_BODY_KEY =
  'combine_requests_request_type_tooltip_combine_body';
export const COMBINE_REQUESTS_REQUEST_TYPE_TOOLTIP_UPGRADE_HEADER_KEY =
  'combine_requests_request_type_tooltip_upgrade_header';
export const COMBINE_REQUESTS_REQUEST_TYPE_TOOLTIP_UPGRADE_BODY_KEY =
  'combine_requests_request_type_tooltip_upgrade_body';
export const COMBINE_REQUESTS_COLUMN_DSP_ACCOUNT_KEY =
  'combine_requests_column_dsp_account';
export const COMBINE_REQUESTS_COLUMN_SA_ACCOUNT_KEY =
  'combine_requests_column_sa_account';
export const COMBINE_REQUESTS_COLUMN_STATUS_KEY =
  'combine_requests_column_status';
export const COMBINE_REQUESTS_COLUMN_REQUESTED_ON_KEY =
  'combine_requests_column_requested_on';
export const COMBINE_REQUESTS_COLUMN_EXPIRES_ON_KEY =
  'combine_requests_column_expires_on';
export const COMBINE_REQUESTS_COLUMN_ACTION_KEY =
  'combine_requests_column_action';
export const COMBINE_REQUESTS_TYPE_COMBINE_KEY =
  'combine_requests_type_combine';
export const COMBINE_REQUESTS_ACTIONS_LABEL_KEY =
  'combine_requests_actions_label';
export const COMBINE_REQUESTS_ACTION_APPROVE_KEY =
  'combine_requests_action_approve';
export const COMBINE_REQUESTS_ACTION_DECLINE_KEY =
  'combine_requests_action_decline';
export const COMBINE_REQUESTS_ACTION_SEND_AGAIN_KEY =
  'combine_requests_action_send_again';
export const COMBINE_REQUESTS_ACTION_CANCEL_KEY =
  'combine_requests_action_cancel';
export const COMBINE_REQUESTS_STATUS_PENDING_KEY =
  'combine_requests_status_pending';
export const COMBINE_REQUESTS_STATUS_APPROVED_KEY =
  'combine_requests_status_approved';
export const COMBINE_REQUESTS_VIEW_CAMPAIGNS_KEY =
  'combine_requests_view_campaigns';

export const COMBINE_REQUESTS_CONFIRM_TITLE_KEY =
  'combine_requests_confirm_title';
export const COMBINE_REQUESTS_CONFIRM_BODY_KEY =
  'combine_requests_confirm_body';
export const COMBINE_REQUESTS_CONFIRM_BULLET_BILLING_KEY =
  'combine_requests_confirm_bullet_billing';
export const COMBINE_REQUESTS_CONFIRM_BULLET_CAMPAIGNS_KEY =
  'combine_requests_confirm_bullet_campaigns';
export const COMBINE_REQUESTS_CONFIRM_BULLET_ADMINS_KEY =
  'combine_requests_confirm_bullet_admins';
export const COMBINE_REQUESTS_CONFIRM_BULLET_FEATURES_KEY =
  'combine_requests_confirm_bullet_features';
export const COMBINE_REQUESTS_CONFIRM_BULLET_MANAGE_KEY =
  'combine_requests_confirm_bullet_manage';
export const COMBINE_REQUESTS_CONFIRM_AGREEMENT_KEY =
  'combine_requests_confirm_agreement';
export const COMBINE_REQUESTS_CONFIRM_SUBMIT_KEY =
  'combine_requests_confirm_submit';
export const COMBINE_REQUESTS_CONFIRM_LOADING_KEY =
  'combine_requests_confirm_loading';
export const COMBINE_REQUESTS_PROGRESS_SNACKBAR_KEY =
  'combine_requests_progress_snackbar';
export const COMBINE_REQUESTS_PROGRESS_SNACKBAR_ONE_KEY =
  'combine_requests_progress_snackbar_one';
export const COMBINE_REQUESTS_SUCCESS_TITLE_KEY =
  'combine_requests_success_title';
export const COMBINE_REQUESTS_SUCCESS_BODY_KEY =
  'combine_requests_success_body';
export const COMBINE_REQUESTS_SUCCESS_ACCOUNT_SETTINGS_KEY =
  'combine_requests_success_account_settings';
export const COMBINE_REQUESTS_SUCCESS_CAMPAIGNS_KEY =
  'combine_requests_success_campaigns';
export const COMBINE_REQUESTS_ACTION_ERROR_KEY =
  'combine_requests_action_error';

// Choose accounts step defaults
export const CHOOSE_ACCOUNTS_HEADING_KEY = 'choose_accounts_heading';
export const CHOOSE_ACCOUNTS_DESCRIPTION_KEY = 'choose_accounts_description';
export const CHOOSE_ACCOUNTS_REQUEST_ACCESS_INFO_KEY =
  'choose_accounts_request_access_info';
export const CHOOSE_ACCOUNTS_NO_ITEMS_SELECTED_KEY =
  'choose_accounts_no_items_selected';
export const CHOOSE_ACCOUNTS_ADD_KEY = 'choose_accounts_add';
export const CHOOSE_ACCOUNTS_ADDED_KEY = 'choose_accounts_added';
export const CHOOSE_ACCOUNTS_REMOVE_KEY = 'choose_accounts_remove';
export const CHOOSE_ACCOUNTS_REMOVE_ALL_KEY = 'choose_accounts_remove_all';

// Remaining copy on the shared Choose accounts surface (task 5.4 / R14.4).
// Everything here renders in BOTH the combine and upgrade lanes except the
// filter dropdown and the Request access tab, which the upgrade lane hides via
// hideFilterBy and hideRequestAccessTab.
export const CHOOSE_ACCOUNTS_SEARCH_KEY = 'choose_accounts_search';
export const CHOOSE_ACCOUNTS_FILTER_BY_KEY = 'choose_accounts_filter_by';
export const CHOOSE_ACCOUNTS_TAB_YOUR_ACCOUNTS_KEY =
  'choose_accounts_tab_your_accounts';
export const CHOOSE_ACCOUNTS_TAB_REQUEST_ACCESS_KEY =
  'choose_accounts_tab_request_access';

// Account-type filter option labels. FILTER_OPTIONS maps its filter keys to
// these Puff keys rather than to English, so the dropdown resolves them at
// render time; the keys themselves ('all', 'sa', 'dsp') remain the filter
// logic's vocabulary and are unaffected.
export const CHOOSE_ACCOUNTS_FILTER_ALL_KEY = 'choose_accounts_filter_all';
export const CHOOSE_ACCOUNTS_FILTER_SA_KEY = 'choose_accounts_filter_sa';
export const CHOOSE_ACCOUNTS_FILTER_DSP_KEY = 'choose_accounts_filter_dsp';

// Selected-panel group headers, one per account type. AccountTypeGroupHeader
// applies text-transform: uppercase, so these stay sentence case and CSS does
// the capitalization; baking capitals into the source copy would force every
// locale to carry them, and casing rules are not universal.
export const CHOOSE_ACCOUNTS_GROUP_HEADER_DSP_KEY =
  'choose_accounts_group_header_dsp';
export const CHOOSE_ACCOUNTS_GROUP_HEADER_SA_KEY =
  'choose_accounts_group_header_sa';

// Accessible label and tooltip on a selected row's remove button.
export const CHOOSE_ACCOUNTS_REMOVE_ACCOUNT_KEY =
  'choose_accounts_remove_account';

// Accessible label on the expand/collapse arrow of a manager account row.
export const CHOOSE_ACCOUNTS_TOGGLE_KEY = 'choose_accounts_toggle';

// Adds every eligible account under one manager account. Upgrade lane only,
// gated by ChooseAccountsStep's allowAddAll prop.
export const CHOOSE_ACCOUNTS_ADD_ALL_KEY = 'choose_accounts_add_all';

// The combine lane's selected count.
//
// Corrected 2026-08-20. This block previously said no combine-lane equivalent
// of upgrade_accounts_selected_count was possible. That was half right:
// SideBySideListBuilder renders labels.selected only when no maxSelections is
// set, so with a max the combine lane's selected label genuinely never renders.
// But Storm falls back to a *different* label in that case,
// items_selected_with_max, which is separately overridable as
// labels.itemsSelectedWithMax. Leaving it unset is what made the combine lane
// render Storm's own English "1/2 selected" in all 27 locales.
//
// Storm's TranslationProvider returns an override verbatim and does NOT
// interpolate values into it, so the count has to be formatted by the caller
// before being passed, exactly as the upgrade lane already does for
// labelsSelected. See the labels prop in ChooseAccountsStep.
export const CHOOSE_ACCOUNTS_SELECTED_WITH_MAX_KEY =
  'choose_accounts_selected_with_max';

// Request access (requester journey)
export const COMBINE_ACCOUNTS_REQUEST_ACCESS_BUTTON_KEY =
  'combine_accounts_request_access_button';
export const COMBINE_ACCOUNTS_REQUEST_ACCESS_ERROR_SAME_TYPE_KEY =
  'combine_accounts_request_access_error_same_type';
export const COMBINE_ACCOUNTS_REQUEST_ACCESS_AGREEMENT_KEY =
  'combine_accounts_request_access_agreement';
export const COMBINE_ACCOUNTS_REQUEST_ACCESS_AGREEMENT_LINK_KEY =
  'combine_accounts_request_access_agreement_link';
// Route that serves the Amazon Ads Agreement, matching the '/terms' route in
// src/routes/router.tsx. Shared by the two account-combination surfaces that
// present the click-through (the request-access tab and the upgrade
// confirmation modal) so they cannot drift apart. Note that
// marketplaceExpansion still opens its own '/terms' literal; consolidating that
// one is out of scope here.
export const AMAZON_ADS_AGREEMENT_PATH = '/terms';
export const COMBINE_ACCOUNTS_REQUEST_SUBMIT_ERROR_KEY =
  'combine_accounts_request_submit_error';
export const COMBINE_ACCOUNTS_REQUEST_ACCESS_INTRO_KEY =
  'combine_accounts_request_access_intro';
export const COMBINE_ACCOUNTS_REQUEST_ACCESS_ACCOUNT_ID_LABEL_KEY =
  'combine_accounts_request_access_account_id_label';
export const COMBINE_ACCOUNTS_REQUEST_ACCESS_PLACEHOLDER_KEY =
  'combine_accounts_request_access_placeholder';
export const COMBINE_ACCOUNTS_REQUEST_ACCESS_ERROR_INVALID_ID_KEY =
  'combine_accounts_request_access_error_invalid_id';
export const COMBINE_ACCOUNTS_REQUEST_ACCESS_HELP_SA_HEADER_KEY =
  'combine_accounts_request_access_help_sa_header';
export const COMBINE_ACCOUNTS_REQUEST_ACCESS_HELP_SA_BODY_KEY =
  'combine_accounts_request_access_help_sa_body';
export const COMBINE_ACCOUNTS_REQUEST_ACCESS_HELP_DSP_HEADER_KEY =
  'combine_accounts_request_access_help_dsp_header';
export const COMBINE_ACCOUNTS_REQUEST_ACCESS_HELP_DSP_BODY_KEY =
  'combine_accounts_request_access_help_dsp_body';

// Terminal "Request submitted" modal (requester journey, Flow 3). Shown only
// after the invitation is actually created; see R2.2.
export const COMBINE_ACCOUNTS_REQUEST_SUBMITTED_HEADER_KEY =
  'combine_accounts_request_submitted_header';
export const COMBINE_ACCOUNTS_REQUEST_SUBMITTED_BODY_KEY =
  'combine_accounts_request_submitted_body';
export const COMBINE_ACCOUNTS_REQUEST_SUBMITTED_EMAIL_NOTE_KEY =
  'combine_accounts_request_submitted_email_note';
export const COMBINE_ACCOUNTS_DONE_KEY = 'combine_accounts_done';

/*
  Copy for the combine's own wait.

  Separate from the upgrade lane's equivalents rather than shared with them. The two read almost
  identically in English and diverge elsewhere, because one merges two existing accounts and the
  other creates one, so a shared string would have to be vague enough to cover both.

  Success has no copy at all: a finished combine redirects straight into campaign manager, on the
  reasoning that the user asked to combine in order to go and use the account.
*/

/**
 * Shown in place of the confirmation modal's body while the combine is being watched.
 *
 * Deliberately not the existing combine_accounts_details_loading, whose value is "Loading account
 * details..." and whose note describes fetching the review page's contents.
 */
export const COMBINE_ACCOUNTS_CONFIRM_LOADING_KEY =
  'combine_accounts_confirm_loading';

/**
 * Snackbar on the landing page while a handed-off combine is still being followed.
 *
 * Carries no count placeholder, unlike upgrade's equivalent. A combine merges exactly one DSP
 * account into one Sponsored ads account, so the number is fixed at two, and by the reasoning
 * already applied to the singular entries above, a placeholder whose value never varies is one a
 * translation can drop without anything noticing.
 */
export const COMBINE_ACCOUNTS_IN_PROGRESS_SNACKBAR_KEY =
  'combine_accounts_in_progress_snackbar';

// A requested account has no name available (the requester has no admin access
// to it), so the selected-list name line shows this placeholder glyph and the
// entered account id is shown beneath it. Per the design mock this is an en
// dash. It is a locale-invariant symbol, so it is a plain constant rather than
// a translated string.
export const PENDING_ACCOUNT_NAME_PLACEHOLDER = '–';
